<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="负责人名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入负责人名称" />
      </a-form-model-item>
      <a-form-model-item label="手机号" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入手机号" />
      </a-form-model-item>
      <a-form-model-item label="结账单号" prop="payNumber" >
        <a-input v-model="form.payNumber" placeholder="请输入结账单号" />
      </a-form-model-item>
      <a-form-model-item label="课程数" prop="course" >
        <a-input v-model="form.course" placeholder="请输入课程数" />
      </a-form-model-item>
      <a-form-model-item label="订单总额" prop="orderMoney" >
        <a-input v-model="form.orderMoney" placeholder="请输入订单总额" />
      </a-form-model-item>
      <a-form-model-item label="课程收入" prop="incomeMoney" >
        <a-input v-model="form.incomeMoney" placeholder="请输入课程收入" />
      </a-form-model-item>
      <a-form-model-item label="平台总抽成" prop="platformMoney" >
        <a-input v-model="form.platformMoney" placeholder="请输入平台总抽成" />
      </a-form-model-item>
      <a-form-model-item label="状态 " prop="type" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.type">
          <a-radio :value=0>未结算</a-radio>
          <a-radio :value=1>已结算</a-radio>
        </a-radio-group>

      </a-form-model-item>
      <a-form-model-item label="账期开始时间" prop="beginTime" >
        <a-date-picker style="width: 100%" v-model="form.beginTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="账期结束时间" prop="endTime" >
        <a-date-picker style="width: 100%" v-model="form.endTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">-->
<!--            保存-->
<!--          </a-button>-->
<!--          <a-button type="dashed" @click="cancel">-->
<!--            取消-->
<!--          </a-button>-->
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getReceipt, addReceipt, updateReceipt } from '@/api/account/receipt'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        payNumber: null,

        course: null,

        name: null,
        mobile: null,

        orderMoney: null,

        incomeMoney: null,

        platformMoney: null,

        type: null,

        beginTime: null,

        endTime: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        payNumber: [
          { required: true, message: '结账单号不能为空', trigger: 'blur' }
        ],
        course: [
          { required: true, message: '课程数不能为空', trigger: 'blur' }
        ],
        orderMoney: [
          { required: true, message: '订单总额不能为空', trigger: 'blur' }
        ],
        incomeMoney: [
          { required: true, message: '课程收入不能为空', trigger: 'blur' }
        ],
        platformMoney: [
          { required: true, message: '平台总抽成不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '状态 不能为空', trigger: 'change' }
        ],
        beginTime: [
          { required: true, message: '账期开始时间不能为空', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '账期结束时间不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        payNumber: null,
        course: null,
        name: null,
        mobile: null,
        orderMoney: null,
        incomeMoney: null,
        platformMoney: null,
        type: null,
        beginTime: null,
        endTime: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getReceipt({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 结算单据 */
    handleAccount (row) {
      this.loading = true
      this.form.id = row.id
      this.form.type = 1
      updateReceipt(this.form).then(response => {
        this.$message.success(
          '结算成功',
          3
        )
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    },


    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateReceipt(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addReceipt(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
